import { render, staticRenderFns } from "./UDFahrzeugCell.vue?vue&type=template&id=04e92df2&scoped=true&"
import script from "./UDFahrzeugCell.vue?vue&type=script&lang=js&"
export * from "./UDFahrzeugCell.vue?vue&type=script&lang=js&"
import style0 from "./UDFahrzeugCell.vue?vue&type=style&index=0&id=04e92df2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e92df2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
